import { useCallback } from 'react';
import { Flex, Typography } from '@banhala/ui-kit';
import type { HeadlineOverlineTimerProps } from './types';
import { isNil, isNotNil } from '../../../../utils';
import { useCountdown } from '../../../../hooks/useCountdown';
import { useOpenDeeplink } from '../../../../hooks';
import { useLogAnalyticsEvent } from '../../../../hooks/useLogAnalyticsEvent';
import { HTMLText } from '../../../HTMLText';

export const HeadlineOverlineTimer = ({
  header,
}: HeadlineOverlineTimerProps) => {
  const { openDeeplink } = useOpenDeeplink();
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const { timeText: timerText } = useCountdown(header?.item.timer?.finished_at);

  const remainingHour = header?.item.timer?.finished_at
    ? Math.max(
        0,
        (new Date(header.item.timer.finished_at).getTime() - Date.now()) /
          3600000,
      )
    : 0;

  const handlePressBanner = useCallback(() => {
    if (isNil(header) || isNil(header.item.deeplink)) return;
    logAnalyticsEvent({
      name: 'CLICK_HEADLINE_OVERLINE_TIMER_MORE',
      analytics: header.logging.analytics,
      ably_only_log: header.logging.ably_only_log,
    });
    openDeeplink(header.item.deeplink);
  }, [header, openDeeplink, logAnalyticsEvent]);

  if (isNil(header)) return null;

  return (
    <Flex padding={{ top: 16, bottom: 8, horizontal: 16 }}>
      <Typography type="body4" color="content_primary">
        {header.item.overline}
      </Typography>
      {isNotNil(header.item.title) ? (
        <Flex margin={{ top: 2 }}>
          <HTMLText type="h3" color="content_primary">
            {header.item.title}
          </HTMLText>
        </Flex>
      ) : (
        isNotNil(timerText) && (
          <Flex margin={{ top: 2 }}>
            <Typography
              type="h3"
              color={
                remainingHour < 24 ? 'content_pink_primary' : 'content_primary'
              }
            >
              {timerText}
            </Typography>
          </Flex>
        )
      )}
      {isNotNil(header.item.banner) && (
        <Flex
          margin={{ top: 8 }}
          backgroundColor="bg_secondary"
          borderRadius={8}
          padding={{ horizontal: 12, vertical: 12 }}
          onPress={handlePressBanner}
        >
          <Typography type="subtitle3" color="content_secondary">
            {header.item.banner.title}
          </Typography>
        </Flex>
      )}
    </Flex>
  );
};
